<p-panel [toggleable]="true" toggler="header">
  <ng-template #header>
    <app-panel-header
      titleKey="project.steps.rfq.invitationPreview.implementation.timeline"
      tooltipKey="project.steps.rfq.invitationPreview.implementation.timeline.tooltip"
    ></app-panel-header>
  </ng-template>
  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  <form [formGroup]="theForm">
    <div class="grid grid-cols-1 gap-4 p-5">
      <p-table [value]="implementationConfigRows()">
        <ng-template #header>
          <tr>
            <th>{{ 'common.functions' | transloco }}</th>
            <th>{{ 'common.office.location' | transloco }}</th>
            <th>{{ 'common.plannedAction' | transloco }}</th>
            <th>{{ 'common.goLiveDate' | transloco }}</th>
            <th>{{ 'common.contractExpiryDate' | transloco }}</th>
          </tr>
        </ng-template>

        <ng-template #body let-row let-i="rowIndex">
          <ng-container formArrayName="data">
            @if (dataArray.controls[i]) {
              <tr [formGroupName]="i">
                <td>
                  {{ row.functionTranslations | translateDirectus }}
                </td>
                <td>{{ row.data.officesLookupResponse.name }}</td>
                <td>
                  <i class="pi pi-new"></i>
                  {{ extractTranslationKey(row.data.plannedAction) | transloco }}
                </td>
                <td>
                  <app-form-field-datepicker
                    id="{{ 'goLiveDate-' + row.data.id }}"
                    view="month"
                    dateFormat="M.yy"
                    fieldName="goLiveDate"
                    [isReadOnly]="isReadOnly()"
                    readOnlyFormat="MMM.yyyy"
                  ></app-form-field-datepicker>
                </td>
                <td>
                  <app-form-field-datepicker
                    id="{{ 'contractExpiryDate-' + row.data.id }}"
                    view="month"
                    dateFormat="M.yy"
                    fieldName="contractExpiryDate"
                    [isReadOnly]="isReadOnly() || !isReplaceSystem(row.data.plannedAction)"
                    readOnlyFormat="MMM.yyyy"
                  ></app-form-field-datepicker>
                </td>
              </tr>
            }
          </ng-container>
        </ng-template>
      </p-table>
    </div>

    @if (theForm.valid && hasChanges()) {
      <div class="flex justify-end gap-2 mt-4">
        <app-project-step-save-button
          [loading]="isSaving()"
          [disabled]="isSaving()"
          (clicked)="onSubmit()"
        ></app-project-step-save-button>
      </div>
    }
  </form>
</p-panel>
